export default "__VITE_ASSET__CQo1eB$X__"